module.exports = __webpack_public_path__ + "img/serviceVITOCROSSALL.dd551c94.webp";